import { login, logout, getInfo } from '@/api/login'
import { teamList } from '@/api/temp'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    temps: [],
    orderId:"",
    roleId:'',
    userId:""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_TEMPS: (state, temps) => {
      state.temps = temps
    },
    SET_ORDERID:(state,  orderId)=>{
      state.orderId = orderId
    },
    SET_ROLEID:(state,  roleId)=>{
      state.roleId = roleId
    },
    SET_USERID:(state,  userId)=>{
      state.userId = userId
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
  async  GetInfo({ commit, state }) {
      return new Promise( (resolve, reject) => {
        getInfo().then( async response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          //获取团队
         await teamList({
            pageNum: 1,
            pageSize: 1000,
          }).then(res=>{
            commit('SET_TEMPS', res.data.list)
          },()=>{
            commit('SET_TEMPS', [])
          })
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          commit('SET_ROLEID', data.roleIds[0])
          commit('SET_USERID', data.id)
          localStorage.setItem("userInfo",JSON.stringify(response.data))
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js